export default __webpack_public_path__ + "static/media/MIGWeldingImg.662667fd.jpg";